function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgSkype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D2F0FF"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73C8F0"
    },
    d: "M256,96.84c-11.511,0-22.731,1.241-33.543,3.576c-12.578-6.755-26.955-10.594-42.232-10.594 c-49.376,0-89.403,40.027-89.403,89.403c0,15.277,3.84,29.653,10.594,42.232C99.081,232.269,97.84,243.489,97.84,255 c0,43.929,17.914,83.67,46.83,112.33l-0.722,0.721l142.175,142.175c117.474-13.773,210.619-107.069,224.162-224.614L368.336,143.664 l-0.006,0.006C339.67,114.754,299.929,96.84,256,96.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2896FF"
    },
    d: "M410.585,288.535c2.334-10.81,3.575-22.027,3.575-33.535c0-87.35-70.811-158.16-158.16-158.16 c-11.508,0-22.725,1.24-33.535,3.575c-12.579-6.756-26.961-10.593-42.24-10.593c-49.376,0-89.403,40.027-89.403,89.403 c0,15.279,3.836,29.66,10.593,42.24C99.08,232.275,97.84,243.492,97.84,255c0,87.35,70.811,158.16,158.16,158.16 c11.508,0,22.725-1.24,33.535-3.575c12.579,6.756,26.961,10.593,42.24,10.593c49.376,0,89.403-40.027,89.403-89.403 C421.178,315.496,417.342,301.115,410.585,288.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M305.816,206.502c-6.676-6.653-29.244-18.224-49.724-18.224c-15.814,0-29.419,5.014-29.419,20.827 c0,16.479,19.437,20.62,42.175,26.294c33.117,8.929,59.356,18.755,59.356,54.67c0,9.893-1.867,18.354-5.596,25.383 c-3.735,7.029-8.766,12.716-15.1,17.052c-23.636,16.188-61.114,14.799-88.905,6.248c-13.538-4.165-25.688-10.064-36.447-17.703 l15.881-30.98c3.46,3.459,19.52,14.446,41.393,20.046c16.371,4.201,50.505,6.405,50.505-16.401c0-13.313-14.208-19.074-28.117-23.17 c-36.308-10.66-72.113-16.301-72.113-55.712c0-37.8,29.975-58.055,67.427-58.055c13.016,0,24.992,2.042,35.926,6.118 c10.935,4.08,20.477,8.896,28.638,14.449L305.816,206.502z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkype);
export default __webpack_public_path__ + "static/media/skype.6f4314a1.svg";
export { ForwardRef as ReactComponent };